export const DOC_TYPES = ['txt', 'rtf', 'pdf'];
export const IMG_TYPES = ['jpeg', 'jpg', 'png', 'bmp', 'image/jpeg', 'image/png', 'image/bmp'];
export const MEDIA_TYPES = ['mp4', 'video/mp4'];
export const ACCEPT_FILES_EXT = [...DOC_TYPES, ...IMG_TYPES, ...MEDIA_TYPES, 'dcm'];
